<template>
  <div v-loading="loading" class="iFrame">
    <template v-if="residence">
      <h4>
        {{ $t('iframe.accomodationFrom') }}
        {{ Math.floor(residence.preview.surface_from) }} {{ $t('iframe.to') }}
        {{ Math.floor(residence.preview.surface_to) }}&nbsp;{{
          $t('iframe.squareFoot')
        }}
      </h4>
      <div class="iFrame__firstLine">
        <div class="iFrame__firstLine-left">
          {{ $t('iframe.rentalFrom') }}
          <span
            >{{ residence.preview.rent_amount_from
            }}{{ $t('iframe.perMonth') }}</span
          ><br />
          {{ $t('iframe.allInclusive') }}
        </div>
        <div class="iFrame__firstLine-right">
          <div
            class="iFrame__firstLine-right-button"
            :class="[
              color,
              residence.preview.availability_count === 0 ? 'disabled' : ''
            ]"
            @click="residence.preview.availability_count && rentResidence()"
          >
            <md-icon name="calendar_today" />
            &nbsp;
            {{ $t('iframe.rent') }}
          </div>
        </div>
      </div>
      <div class="iFrame__legend">
        <div class="iFrame__legend-item">
          <md-icon name="calendar_today" />
          <span>{{ $t('iframe.legend1') }}</span>
        </div>
        <div class="iFrame__legend-item">
          <md-icon name="calendar_today" />
          <span>{{ $t('iframe.legend2') }}</span>
        </div>
        <div class="iFrame__legend-item">
          <md-icon name="calendar_today" />
          <span>{{ $t('iframe.legend3') }}</span>
        </div>
      </div>
      <template v-if="residence.preview.availability_count === 0">
        <h4>{{ $t('iframe.noRental') }}</h4>
        <el-link :underline="false" target="_parent" @click="related()">{{
          $t('iframe.otherResidences')
        }}</el-link>
      </template>
    </template>
  </div>
</template>

<script>
export default {
  name: 'IFrame',
  data: () => ({
    loading: false,
    residence: null
  }),
  computed: {
    color() {
      if (this.residence) {
        if (this.residence.preview.availability_count === 0) {
          return 'default'
        } else if (this.residence.preview.availability_count <= 5) {
          return 'orange'
        } else if (this.residence.preview.availability_count > 5) {
          return 'green'
        }
      }

      return 'default'
    },
    url() {
      if (this.$route && this.$route.params.id) {
        return (
          window.location.protocol +
          '//' +
          window.location.hostname +
          (window.location.port ? ':' + window.location.port : '') +
          '/residences/' +
          this.$route.params.id +
          '/reservation-d-un-logement'
        )
      }

      return null
    }
  },
  async mounted() {
    if (this.$route && this.$route.params.id) {
      this.loading = true
      try {
        this.residence = await this.$api.residences.getResidencePreview({
          id: this.$route.params.id
        })
      } catch (error) {
        console.warn(error)
      }
      this.loading = false
    }
  },
  methods: {
    rentResidence() {
      top.window.location.href = this.url
    },
    related() {
      top.window.location.href = this.$route.query.url + '#related'
    }
  }
}
</script>

<style lang="scss" scoped>
$c: '.iFrame';

#{$c} {
  box-sizing: border-box;
  width: 100%;
  background-color: #ffffff;
  padding: 24px;
  user-select: none;

  a {
    cursor: pointer;
    text-decoration: underline;
    font-size: 16px;
    color: $--color-text-regular;
  }

  h4 {
    line-height: 1.64;
    font-size: 20px;
  }

  &__firstLine {
    margin-top: 8px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;

    &-left {
      flex: 60% 0;
      span {
        color: $--color-primary;
      }
    }

    &-right {
      flex: 40% 0;
      display: flex;
      justify-content: flex-end;

      &-button {
        cursor: pointer;
        right: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 112px;
        height: 32px;
        border-radius: 3px;
        color: white;

        &.default {
          background-color: #cb4a43;
        }

        &.orange {
          background-color: #dc885c;
        }

        &.green {
          background-color: #58928f;
        }
      }
    }
  }

  &__legend {
    margin: 24px 0;
    display: flex;
    flex-direction: row;

    &-item {
      flex: 33% 0;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;

      i {
        padding: 16px;
        margin-bottom: 4px;
        color: #ffffff;
        border-radius: 50%;
      }

      span {
        display: block;
        text-align: center;
        font-size: 14px;
        color: #606266;
      }

      &:first-child {
        i {
          background-color: #cb4a43;
        }
      }

      &:nth-child(2) {
        i {
          background-color: #dc885c;
        }
      }

      &:nth-child(3) {
        i {
          background-color: #58928f;
        }
      }
    }
  }
}
</style>
